import { createContext, useContext } from "react";

export interface TenantSearchFilterContextValue {
  hasInitializedDefaults: boolean;
  initializeDefaults: (
    filters: Record<string, string[]>,
    sources: string[],
    defaultsPlan: {
      sourceKey: string;
      childFilters: { id: string; value: unknown }[];
    } | null
  ) => { filters: Record<string, string[]>; sources: string[] };
  markDefaultsInitialized: () => void;
}

export const TenantSearchFilterContext = createContext<
  TenantSearchFilterContextValue | undefined
>(undefined);

const useTenantSearchFilterContext = () => {
  const context = useContext(TenantSearchFilterContext);
  if (!context) {
    throw new Error(
      "useTenantSearchFilterContext must be used within LegislationFilterConfigProvider"
    );
  }
  return context;
};

export const useTenantSearchFilterState = () => {
  return useTenantSearchFilterContext();
};
